const FacebookBoxIcon = () => {
  return (
    <svg
      width="123"
      height="124"
      viewBox="0 0 123 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <rect x="22" y="13" width="79" height="79" rx="16" fill="#1877F2" />
      </g>
      <path
        d="M80 52.11C80 42.1081 71.9411 34 62 34C52.0589 34 44 42.1081 44 52.11C44 61.1492 50.5823 68.6414 59.1875 70V57.3449H54.6172V52.11H59.1875V48.1201C59.1875 43.5813 61.8748 41.0742 65.9864 41.0742C67.9557 41.0742 70.0156 41.4279 70.0156 41.4279V45.8847H67.7459C65.5098 45.8847 64.8125 47.2807 64.8125 48.7129V52.11H69.8047L69.0066 57.3449H64.8125V70C73.4177 68.6414 80 61.1492 80 52.11Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0.698332"
          width="123"
          height="123"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="9.69833" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FacebookBoxIcon;
